import StripePlans from './StripePlans';

export default {
    mixins: [StripePlans, require('mixins/subscriptions')],

    computed: {
        /**
         * @override from Spark mixins subscriptions.js
         */
        activePlan() {
            if (this.activeSubscription) {
                return this.stripePlans.find(plan => {
                    return plan.id == this.activeSubscription.provider_plan;
                });
            }
        },
    },
};
